import { useProductSupplierResponsesTemplate } from "./useProductSupplierResponsesTemplate";

export default function useProductSupplierResponsesGridTemplate() {
  const template = useProductSupplierResponsesTemplate();
  
  // For now, no hidden columns logic - just return the template as a grid string
  // Can be extended later to support column visibility like the main table
  
  return template.join(" ");
}

